<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <span class="etms-router-search-label fl">网点名称：</span>
      <el-input size="mini" v-model="search.BranchesName" placeholder="网点名称搜索" class="etms-router-search-element fl"></el-input>
      <span class="etms-router-search-label fl">网点编码：</span>
      <el-input size="mini" v-model="search.BranchesCode" placeholder="网点编码搜索" class="etms-router-search-element fl"></el-input>
      <span class="etms-router-search-label fl">地区：</span>
      <el-cascader size="mini" :options="regionmodule.regions" v-model="search.Regions" filterable placeholder="请选择所在地区" class="etms-router-search-label fl"></el-cascader>
      <span class="etms-router-search-label fl">联系人：</span>
      <el-input size="mini" v-model="search.Contacts" placeholder="联系人搜索" class="etms-router-search-element fl"></el-input>
      <span class="etms-router-search-label fl">性质：</span>
      <el-select size="mini" v-model="search.BranchesNature" placeholder="网点性质搜索" class="etms-router-search-element el-width-130 fl">
        <el-option v-for="item in constant.branchesnatures" :label="item" :value="item" :key="item"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">状态：</span>
      <el-select size="mini" v-model="search.BranchesState" placeholder="网点状态搜索" class="etms-router-search-element el-width-130 fl">
        <el-option v-for="item in constant.branchesstates" :label="item" :value="item" :key="item"></el-option>
      </el-select>
      <el-tooltip class="item" effect="dark" content="添加网点信息" placement="top">
        <el-button size="mini" @click="insetrBranches" class="etms-router-search-button fr" type="primary" icon="el-icon-plus"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="查询网点信息" placement="top">
        <el-button size="mini" @click="searchClick" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
      </el-tooltip>
      <div class="clear"></div>
    </div>
    <el-table :border="true" :data="branchess" height="90%" class="etms-router-list">
      <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
      <el-table-column label="网点" width="250px">
        <template slot-scope="scope"><span>名称：{{scope.row.branchesName}} </span><span>编码：{{scope.row.branchesCode}}</span></template>
      </el-table-column>
      <el-table-column label="地址" prop="regions" :formatter="formatterRegion">
      </el-table-column>
      <el-table-column label="联系电话" prop="contactPhone" width="220px"></el-table-column>
      <el-table-column label="联系人" prop="contacts" width="100px"></el-table-column>
      <el-table-column label="业务范围" prop="businessScope"></el-table-column>
      <el-table-column label="状态/性质" prop="branchesState" :formatter="formatterState" width="100px"></el-table-column>
      <el-table-column label="操作" width="140px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改网点信息" placement="top">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index,scope.row)" icon="el-icon-edit-outline" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除网点" placement="top">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)" icon="el-icon-delete" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search.pageindex" :page-sizes="constant.pagesizes" :page-size="search.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="search.recordcount"></el-pagination>
    <el-dialog :title="dialogtitle" :visible.sync="dialogvisible" :modal-append-to-body="false" width="850px" center>
      <el-tabs v-model="activename" @tab-click="handleClick">
        <el-tab-pane label="网点信息" name="branchesinfo">
          <el-form :model="form" :rules="rules" :ref="form.formname" label-width="120px" class="el-form-half etms-dialog-form">
            <el-form-item label="网点名称 ：" prop="BranchesName">
              <el-input size="mini" v-model="form.BranchesName" placeholder="请输入网点名称" class="el-width-250" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="网点编码 ：" prop="BranchesCode">
              <el-input size="mini" v-model="form.BranchesCode" placeholder="请输入网点编码(1-10个字符)" class="el-width-250" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="网点分类 ：" prop="BranchesType">
              <el-select size="mini" v-model="form.BranchesType" placeholder="请选网点分类" multiple class="el-width-250">
                <el-option v-for="item in constant.businessTypes" :label="item.label" :value="item.value" :key="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地区 ：" prop="Regions">
              <el-cascader size="mini" placeholder="请选择所在地区" :options="regionmodule.regions" v-model="form.Regions" filterable class="el-width-250"></el-cascader>
            </el-form-item>
            <el-form-item label="街道 ：" prop="Street">
              <el-input size="mini" placeholder="请填写网点所在街道" v-model="form.Street" class="el-width-250" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="地址 ：" prop="Address">
              <el-input size="mini" placeholder="请填写网点详细地址(请具体到门牌号)" v-model="form.Address" class="el-width-250" maxlength="100" @blur="baiduMapInit"></el-input>
            </el-form-item>
            <el-form-item label="联系人 ：" prop="Contacts">
              <el-input size="mini" placeholder="请填写联系人称呼" v-model="form.Contacts" class="el-width-250" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="联系电话 ：" prop="ContactPhone">
              <el-input size="mini" placeholder="请填写联系电话(多个可以用空格或者逗号分隔开)" v-model="form.ContactPhone" class="el-width-250" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="网点性质 ：" prop="BranchesNature">
              <el-select size="mini" v-model="form.BranchesNature" placeholder="请选择网点性质" class="el-width-250">
                <el-option v-for="item in constant.branchesnatures" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="网点状态 ：" prop="BranchesState">
              <el-select size="mini" v-model="form.BranchesState" placeholder="请选择网点状态" class="el-width-250">
                <el-option v-for="item in constant.branchesstates" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务范围 ：" prop="BusinessScope">
              <el-input size="mini" v-model="form.BusinessScope" placeholder="网点业务经营范围" class="el-width-250" maxlength="500"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="网点地图" name="baidumap">
          <div id="baidumap" class="baidumap"></div>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogvisible=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    var branchesCodeValidate = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax.post(this.constant.openPaths.existsBranchesCode, {
          UserId: userinfo.id,
          EnterpriseId: userinfo.enterpriseId,
          LoginToken: userinfo.loginToken,
          BranchesCode: value,
          BranchesId: self.form.BranchesId
        }).then(res => {
          if (res.data.code === 200) {
            callback()
          }
          else {
            callback(res.data.msg)
          }
        }).catch(error => { callback(error) })
      }
    }
    return {
      userinfo: this.$cookies.get('userinfo'),
      dialogtitle: '',
      dialogvisible: false,
      activename: 'branchesinfo',
      search: {
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
        BranchesName: '',
        BranchesCode: '',
        Contacts: '',
        Regions: [],
        BranchesNature: '',
        BranchesState: ''
      },
      form: {
        formname: 'branchesform',
        BranchesId: '',
        OptimisticLock: '',
        BranchesName: '',
        BranchesType: [],
        Regions: [],
        Street: '',
        Address: '',
        Contacts: '',
        ContactPhone: '',
        BranchesNature: '',
        BranchesState: '',
        BusinessScope: '',
        lng: 113.290374,
        lat: 23.238916
      },
      branchess: [],
      rules: {
        BranchesName: [
          { required: true, message: '请填写网点名称', trigger: 'blur' },
          { max: 50, message: '长度在50个字符内', trigger: 'blur' }
        ],
        BranchesCode: [
          { required: true, message: '请填写网点编码', trigger: 'blur' },
          { max: 10, message: '长度在10个字符内', trigger: 'blur' },
          { validator: branchesCodeValidate, trigger: 'blur' }
        ],
        BranchesType: [
          { required: true, message: '请选择网点分类', trigger: 'change' },
        ],
        Regions: [
          { required: true, message: '请选择网点所在地区', trigger: 'change' },
        ],
        Street: [
          { max: 30, message: '长度在30个字符内', trigger: 'blur' },
        ],
        Address: [
          { required: true, message: '请填写网点详细地址', trigger: 'blur' },
          { max: 100, message: '长度控制在100个字符内', trigger: 'blur' },
        ],
        Contacts: [
          { required: true, message: '请填写网点联系人', trigger: 'blur' },
          { max: 20, message: '长度控制在20个字符内', trigger: 'blur' },
        ],
        ContactPhone: [
          { required: true, message: '请填写网点联系电话', trigger: 'blur' },
          { max: 20, message: '长度控制在20个字符内', trigger: 'blur' },
        ],
        BranchesNature: [
          { required: true, message: '请选择网点性质', trigger: 'change' },
        ],
        BranchesState: [
          { required: true, message: '请选择网点状态', trigger: 'change' },
        ],
        BusinessScope: [
          { required: true, message: '请填写网点经营范围', trigger: 'blur' },
          { max: 500, message: '长度控制在500个字符内', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.searchClick()
  },
  methods: {
    searchClick () {
      var self = this

      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PageSize: this.search.pagesize,
          PageIndex: this.search.pageindex,
          BranchesName: this.search.BranchesName,
          BranchesCode: this.search.BranchesCode,
          Contacts: this.search.Contacts,
          Regions: this.search.Regions,
          BranchesNature: this.search.BranchesNature,
          BranchesState: this.search.BranchesState
        }

        this.$ajax.post(this.constant.openPaths.searchBranchesPager, data).then(res => {
          if (res.data.code === 200) {
            var result = res.data.result
            self.branchess = result.tList
            self.search.recordcount = result.recordCount
          } else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    clearForm () {
      var form = this.form
      Object.keys(form).forEach(item => {
        if (item !== 'formname') {
          switch (typeof (form[item])) {
            case 'string':
              form[item] = ''
              break
            case 'number':
              form[item] = 0
              break
            case 'object':
              if (Array.isArray(form[item])) {
                form[item] = []
              } else { }
              break
          }
        }
      })
    },
    insetrBranches () {
      this.dialogtitle = '添加网点'
      this.dialogvisible = true
      this.clearForm()
      this.baiduMapInit()
    },
    dialogSave () {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          BranchesId: this.form.BranchesId,
          OptimisticLock: this.form.OptimisticLock,
          BranchesName: this.form.BranchesName,
          BranchesCode: this.form.BranchesCode,
          BranchesType: this.form.BranchesType,
          Regions: this.form.Regions,
          Street: this.form.Street,
          Address: this.form.Address,
          Contacts: this.form.Contacts,
          ContactPhone: this.form.ContactPhone,
          BranchesNature: this.form.BranchesNature,
          BranchesState: this.form.BranchesState,
          BusinessScope: this.form.BusinessScope,
          Longitude: this.form.lng,
          Latitude: this.form.lat
        }
        var url = ''
        if (data.BranchesId === '' && data.OptimisticLock === '') {
          url = this.constant.openPaths.insertBranchesModel
        }
        else {
          url = this.constant.openPaths.updateBranchesModel
        }
        var self = this

        this.$refs[this.form.formname].validate(vali => {
          if (vali) {
            if (data.Longitude > 0 && data.Latitude > 0) {
              self.$ajax.post(url, data).then(res => {
                if (res.data.code === 200) {
                  self.$message({ message: res.data.msg, type: 'success' })
                  self.clearForm()
                  self.searchClick()
                  self.dialogvisible = false
                } else { self.$message.error(res.data.msg) }
              }).catch(error => {
                self.$message.error(error)
              })
            }
            else { this.$message.error('地址坐标不存在,请根据地址修正') }
          }
        })
      }
    },
    handleEdit (index, row) {
      this.dialogtitle = '修改网点'
      this.dialogvisible = true
      this.form.Address = row.address
      this.form.BranchesId = row.id
      this.form.OptimisticLock = row.optimisticLock
      this.form.BranchesName = row.branchesName
      this.form.BranchesCode = row.branchesCode
      this.form.BranchesNature = row.branchesNature
      this.form.BranchesState = row.branchesState
      this.form.BranchesType = row.branchesType.split(',')
      this.form.BusinessScope = row.businessScope
      this.form.ContactPhone = row.contactPhone
      this.form.Contacts = row.contacts
      this.form.lng = row.longitude
      this.form.lat = row.latitude
      this.form.Regions = row.regions.split(',')
      this.form.Street = row.street
      this.baiduMapInit()
    },
    handleDelete (index, row) {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          BranchesId: row.id,
          OptimisticLock: row.optimisticLock
        }
        var self = this

        this.$confirm('此操作将永久删除该网点,删除后不可恢复,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$ajax.post(this.constant.openPaths.deleteBranchesModel, data).then(res => {
            if (res.data.code === 200) {
              self.$message({ message: res.data.msg, type: 'success' })
              self.branchess.splice(index, 1)
            } else {
              self.$message.error(res.data.code)
            }
          }).catch(error => {
            self.$message.error(error)
          })
        }).catch(() => { })
      }
    },
    handleSizeChange (val) {
      this.search.pagesize = val
      this.searchClick()
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.searchClick()
    },
    regionShow (regionitem, regionvalues, index) {
      if (index >= regionvalues.length)
        return ''
      var regionvalue = regionvalues[index]

      var region = regionitem.filter(item => item.value === regionvalue)[0]

      if (region != null) {
        var result = region.label
        index += 1
        if (region.children !== null && region.children !== undefined)
          result += ' ' + this.regionShow(region.children, regionvalues, index)
        return result
      }
      return ''
    },
    formatterRegion (row, column, cellvalue) {
      return this.regionShow(this.regionmodule.regions, cellvalue.split(','), 0) + ' ' + row.street + ' ' + row.address
    },
    formatterState (row, column, cellvalue) {
      return cellvalue + '/' + row.branchesNature
    },
    handleClick (tab, event) {
      if (tab.name === 'baidumap') {
        this.baiduMapInit()
      }
    },
    baiduMapInit () {
      var map = new BMap.Map("baidumap")

      map.enableScrollWheelZoom(true)//允许鼠标缩放地图

      var self = this

      if (this.form.lng === 0 && this.form.lat === 0) {
        var branchregion = this.regionmodule.regionEach(this.form.Regions, this.regionmodule.regions, 0)
        if (branchregion === '' || branchregion === null || branchregion === undefined) {
          branchregion = '广州'
        }
        var address = this.form.Street + this.form.Address
        if (address.length < 1) {
          address = '广州塔'
        }
        var myGeo = new BMap.Geocoder();


        myGeo.getPoint(address, function (point) {
          if (point) {
            self.form.lng = point.lng
            self.form.lat = point.lat
            if (point.lng > 0 && point.lat > 0) {
              map.centerAndZoom(point, 17)
            }
            else {
              map.centerAndZoom('广州', 17)
            }
            var marker = new BMap.Marker(point)
            map.addOverlay(marker)

            marker.enableDragging()
            marker.addEventListener('dragend', (e) => {
              self.form.lng = e.point.lng
              self.form.lat = e.point.lat
            })
          } else {
            self.$message.error("您选择地址没有解析到结果!");
          }
        }, branchregion);
      }
      else {
        var point = new BMap.Point(this.form.lng, this.form.lat)
        if (point.lng > 0 && point.lat > 0) {
          map.centerAndZoom(point, 17)
        }
        else {
          map.centerAndZoom('广州', 17)
        }
        var marker = new BMap.Marker(point)
        map.addOverlay(marker)

        marker.enableDragging()
        marker.addEventListener('dragend', (e) => {
          self.form.lng = e.point.lng
          self.form.lat = e.point.lat
        })
      }
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
#baidumap {
  width: 100%;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/ems/branches_manage.vue